/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.ReregisterController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { ReregisterRequest } from '../models/reregister-request';
import { WorkExperiencePeriodModel } from '../models/work-experience-period-model';
import { ZaakModel } from '../models/zaak-model';

@Injectable()
export class ReregisterApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }


    public applyForReregistration(request: ReregisterRequest, spinnerMessage: string = null): Observable<ZaakModel> {
        return this.httpClient.post<ZaakModel>(`/api/reregister`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public validateWorkExperiencePeriod(period: WorkExperiencePeriodModel, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/reregister/validate-period`, period,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
